import React from 'react';
import { Helmet } from 'react-helmet';

function SEO({
    title = 'Window Cleaning Fredericton, NB | Gutter Cleaning | Prestige Clean',
    description = 'Professional window cleaning and gutter cleaning in Fredericton, NB for homes and businesses. Also offering house washing, pressure washing, and polymeric sanding. Free quotes.',
    keywords = 'window cleaning fredericton, gutter cleaning fredericton, house washing fredericton, pressure washing fredericton, polymeric sanding fredericton, fredericton window cleaning, fredericton gutter cleaning, exterior cleaning fredericton, commercial window cleaning fredericton',
    canonicalUrl = 'https://prestigecleanhomeservices.ca',
    image = 'https://prestigecleanhomeservices.ca/og-image.jpg',
    type = 'website',
    structuredData = [],
}) {
    const baseStructuredData = {
        '@context': 'https://schema.org',
        '@type': 'ProfessionalService',
        name: 'Prestige Clean Home Services',
        image: image,
        description,
        address: {
            '@type': 'PostalAddress',
            streetAddress: '46 Haileys Way',
            addressLocality: 'Fredericton',
            addressRegion: 'NB',
            postalCode: 'E3B 0T6',
            addressCountry: 'CA',
        },
        geo: {
            '@type': 'GeoCoordinates',
            latitude: '45.95135452454288',
            longitude: '-66.70506489953013',
        },
        url: canonicalUrl,
        telephone: '+1 506 471 6129',
        openingHoursSpecification: {
            '@type': 'OpeningHoursSpecification',
            dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
            opens: '08:00',
            closes: '18:00',
        },
        sameAs: [
            'https://www.facebook.com/profile.php?id=100092660852751',
            'https://www.instagram.com/prestigecleanwindows/',
        ],
        priceRange: '$$',
        areaServed: [
            { '@type': 'City', name: 'Fredericton' },
            { '@type': 'City', name: 'New Maryland' },
            { '@type': 'City', name: 'Hanwell' },
            { '@type': 'City', name: 'Oromocto' },
            { '@type': 'AdministrativeArea', name: 'New Brunswick' },
        ],
        serviceType: [
            'Window Cleaning',
            'Gutter Cleaning',
            'House Washing',
            'Pressure Washing',
            'Polymeric Sanding',
        ],
        hasOfferCatalog: {
            '@type': 'OfferCatalog',
            name: 'Window, Gutter, and Exterior Cleaning Services',
            itemListElement: [
                {
                    '@type': 'Offer',
                    itemOffered: {
                        '@type': 'Service',
                        name: 'Window Cleaning Fredericton',
                        areaServed: 'Fredericton, New Brunswick',
                        description: 'Professional window cleaning services in Fredericton for residential and commercial properties',
                    },
                },
                {
                    '@type': 'Offer',
                    itemOffered: {
                        '@type': 'Service',
                        name: 'Gutter Cleaning Fredericton',
                        areaServed: 'Fredericton, New Brunswick',
                        description: 'Thorough gutter cleaning and maintenance services in Fredericton',
                    },
                },
                {
                    '@type': 'Offer',
                    itemOffered: {
                        '@type': 'Service',
                        name: 'Polymeric Sanding',
                        description: 'Professional polymeric sanding services for your property',
                    },
                },
                {
                    '@type': 'Offer',
                    itemOffered: {
                        '@type': 'Service',
                        name: 'House Washing',
                        description: 'Professional house washing services for residential exteriors',
                    },
                },
                {
                    '@type': 'Offer',
                    itemOffered: {
                        '@type': 'Service',
                        name: 'Pressure Washing',
                        description: 'Professional pressure washing services for hard outdoor surfaces',
                    },
                },
            ],
        },
    };

    const allStructuredData = [baseStructuredData, ...structuredData];

    return (
        <Helmet>
            <title>{title}</title>
            <meta name="description" content={description} />
            <meta name="keywords" content={keywords} />
            <meta name="robots" content="index, follow" />
            <link rel="canonical" href={canonicalUrl} />

            <meta property="og:type" content={type} />
            <meta property="og:site_name" content="Prestige Clean Home Services" />
            <meta property="og:locale" content="en_CA" />
            <meta property="og:url" content={canonicalUrl} />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={image} />

            <meta property="twitter:card" content="summary_large_image" />
            <meta property="twitter:url" content={canonicalUrl} />
            <meta property="twitter:title" content={title} />
            <meta property="twitter:description" content={description} />
            <meta property="twitter:image" content={image} />

            {allStructuredData.map((item, index) => (
                <script key={index} type="application/ld+json">
                    {JSON.stringify(item)}
                </script>
            ))}
        </Helmet>
    );
}

export default SEO;
